<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('inventoryListByWarehouse.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('inventoryListByWarehouse.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <Tabs @on-click="changeTab">
        <TabPane label="Summary" icon="md-list">
          <ts-loading-banner :loading="loading">
            <summary-report ref="summaryReport"></summary-report>
          </ts-loading-banner>
        </TabPane>
        <TabPane label="Detail" icon="md-apps">
          <ts-loading-banner :loading="loading">
            <detail-report ref="DetailReport"></detail-report>
          </ts-loading-banner>
        </TabPane>
      </Tabs>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SummaryReport from './summary-report.vue'
import DetailReport from './detail-report.vue'
import { debounce } from 'lodash'

export default {
  name: 'inventoryListByWarehouseIndex',
  components: {
    SummaryReport,
    DetailReport
  },
  data () {
    return {
      loading: false,
      showForm: false,
      exporting: false,
      columnHeader: [],
      columnsList: []
    }
  },
  computed: {
    ...mapState('report/inventoryListByWarehouse', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.report.inventoryListByWarehouse.search
      },
      set (newValue) {
        this.$store.commit(
          'report/inventoryListByWarehouse/SET_SEARCH',
          newValue
        )
        this.$store.commit('report/inventoryListByWarehouse/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    changeTab (e) {
      if (e == 0) {
        this.$refs.summaryReport.fetchData()
      } else {
        this.$refs.DetailReport.fetchData()
      }
    },
    async fetchData (attributes) {
      this.loading = true
      await this.$store
        .dispatch('report/inventoryListByWarehouse/getHeader')
        .then(response => {
          this.columnHeader = response.column_header
          this.columnsList = response.column_list
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.$store
        .dispatch('report/inventoryListByWarehouse/fetch', {
          ...attributes
        })
        .then(() => {})
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/inventoryListByWarehouse/RESET_STATE')
    next()
  }
}
</script>
<style scoped>
.text-left {
  text-align: left;
}
</style>
